import t from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const d = {
  display: "block"
}, V = ({ size: a = 16, useVw: o, useRem: c, color: n, withColor: e, removeClassName: l, disableSSR: p, style: i, ...h }) => {
  const m = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ t.createElement(x, { disableSSR: p }, /* @__PURE__ */ t.createElement("svg", { "data-icon-id": "32px-dingtoulicai", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: o ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (c ? "rem" : "px"), height: o ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (c ? "rem" : "px"), className: l ? "" : "iconpark-icon", style: m, fill: "none", ...h }, /* @__PURE__ */ t.createElement(
    "g",
    {
      className: l ? "" : "32px-å®æçè´¢"
    },
    /* @__PURE__ */ t.createElement(
      "path",
      {
        className: l ? "" : "normal",
        d: "M11.237 5.2a.967.967 0 1 0-1.934 0v1.532H7.87a3.837 3.837 0 0 0-3.837 3.837V23.83a3.837 3.837 0 0 0 3.837 3.837h.376c1.593 0 3.02-.984 3.586-2.473l1.5-3.947a.946.946 0 0 1 1.25-.537l2.016.84a2.88 2.88 0 0 0 3.84-1.747l1.74-5.221a.967.967 0 1 0-1.834-.612l-1.74 5.222a.946.946 0 0 1-1.262.574l-2.017-.84a2.88 2.88 0 0 0-3.8 1.634l-1.5 3.947a1.903 1.903 0 0 1-1.779 1.226H7.87a1.903 1.903 0 0 1-1.903-1.903V10.57c0-1.052.852-1.903 1.903-1.903h1.433V10.2a.967.967 0 1 0 1.934 0V8.667h9.527V10.2a.967.967 0 1 0 1.934 0V8.667h1.433c1.05 0 1.902.851 1.902 1.902V23.83a1.903 1.903 0 0 1-1.902 1.903h-8.68a.967.967 0 0 0 0 1.934h8.68a3.837 3.837 0 0 0 3.836-3.837V10.57a3.837 3.837 0 0 0-3.836-3.838h-1.433V5.2a.967.967 0 1 0-1.934 0v1.532h-9.527V5.2Z",
        fill: e ? r(n, 0, "#262933") : "#262933",
        datafollowfill: e ? r(n, 0, "#262933") : "#262933"
      }
    )
  )));
}, E = V;
export {
  E as default
};
